import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { fetchItems } from "../../features/items/itemThunks";
import {
  selectItemsLoading,
  selectItemsError,
} from "../../features/items/itemSelectors";
import ProductListings from "../../pages/ProductListings/ProductListings";
import sliderImage1 from "../../images/Slider-Image1.png";
import sliderImage2 from "../../images/Slider-Image2.png";

const slides = [
  {
    id: 1,
    title: "Up to 10%",
    subtitle: "off Voucher",
    product: "iPhone 14 Series",
    brand: "Apple",
    buttonText: "Shop Now",
    slideNumber: 1,
    image: sliderImage1,
  },
  {
    id: 2,
    title: "Up to 15%",
    subtitle: "off Voucher",
    product: "Samsung Galaxy S24",
    brand: "Samsung",
    buttonText: "Shop Now",
    slideNumber: 2,
    image: sliderImage2,
  },
];

const HomePage = () => {
  const dispatch = useAppDispatch();
  useAppSelector(selectItemsLoading);
  useAppSelector(selectItemsError);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Fetch items on component mount
  useEffect(() => {
    dispatch(fetchItems());
  }, [dispatch]);

  // Auto-play slider effect
  useEffect(() => {
    const sliderTimer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(sliderTimer);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      {/* Main Promotional Banner Slider */}
      <section className="promotional-banner">
        <div className="banner-container">
          {/* Slider Container */}
          <div className="slider-container">
            <div
              className="slider-track"
              style={{
                width: `${slides.length * 100}%`,
                transform: `translate3d(-${(currentSlide * 100) / slides.length}%, 0, 0)`,
              }}
            >
              {slides.map((slide) => (
                <div
                  key={slide.id}
                  className="slide"
                  style={{
                    width: `${100 / slides.length}%`,
                    minWidth: `${100 / slides.length}%`,
                  }}
                >
                  <div className="product-image">
                    <img
                      src={slide.image}
                      alt={slide.product}
                      className="slide-background-image"
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Slider Navigation */}
            <button className="slider-nav prev" onClick={prevSlide}>
              <svg viewBox="0 0 24 24" fill="white">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </button>
            <button className="slider-nav next" onClick={nextSlide}>
              <svg viewBox="0 0 24 24" fill="white">
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </button>
          </div>

          {/* Slider Controls */}
          <div className="banner-bottom">
            <div className="carousel-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentSlide ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                ></span>
              ))}
            </div>
            <div className="carousel-button">{currentSlide + 1}</div>
          </div>
        </div>
      </section>

      {/* Product Listings Section */}
      <ProductListings />
    </>
  );
};

export default HomePage;
